export const Categories = [
  { id: 1, name: "Smartphones", image: "/category-images/smartphones.jpg" },
  { id: 2, name: "Laptops", image: "/category-images/laptops.jpg" },
  { id: 3, name: "Tablets", image: "/category-images/tablets.jpg" },
  { id: 4, name: "TVs & Monitors", image: "/category-images/tvs.jpg" },
  { id: 5, name: "Gaming", image: "/category-images/gaming.jpg" },
  { id: 6, name: "Audio", image: "/category-images/audio.jpg" },
  { id: 7, name: "Cameras", image: "/category-images/cameras.jpg" },
  { id: 8, name: "Wearables", image: "https://images.unsplash.com/photo-1546868871-af0de0ae72be?w=500&q=80" },
  { id: 9, name: "Accessories", image: "https://images.unsplash.com/photo-1625772452859-1c03d5bf1137?w=500&q=80" },
  { id: 10, name: "Networking", image: "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=500&q=80" },
  { id: 11, name: "Components", image: "https://images.unsplash.com/photo-1591799264318-7e6ef8ddb7ea?w=500&q=80" },
  { id: 12, name: "Printers", image: "https://images.unsplash.com/photo-1612815154858-60aa4c59eaa6?w=500&q=80" },
];
